var exports = {
  "nw": "outerContainer__jRPwYU",
  "Uo": "outerContainerAbsolute__FiuR1L",
  "Nt": "outerContainerRelative__26T3Yo",
  "r6": "innerCircle__k5NEdY",
  "Kk": "icon__64QsJa",
};

module.exports = exports;
